export default __webpack_public_path__ + "static/media/bg_sprites.d05251d0.webp";